import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // SEO: Set language
    document.documentElement.lang = 'es';
    // SEO: Add meta description
    if (!document.querySelector('meta[name="description"]')) {
      const desc = document.createElement('meta');
      desc.name = 'description';
      desc.content = 'Método Mesa en Paz: El sistema completo para que tu hijo pase de rechazar todo a explorar alimentos nuevos. 4 Tomos + 2 Bonos. Para familias argentinas.';
      document.head.appendChild(desc);
    }
    // SEO: Ensure viewport meta
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(viewport);
    }
    // Performance: Preconnect to Google Fonts + non-blocking font load
    if (!document.querySelector('link[href="https://fonts.googleapis.com"]')) {
      const preconnect1 = document.createElement('link');
      preconnect1.rel = 'preconnect';
      preconnect1.href = 'https://fonts.googleapis.com';
      document.head.insertBefore(preconnect1, document.head.firstChild);
      const preconnect2 = document.createElement('link');
      preconnect2.rel = 'preconnect';
      preconnect2.href = 'https://fonts.gstatic.com';
      preconnect2.crossOrigin = 'anonymous';
      document.head.insertBefore(preconnect2, preconnect1.nextSibling);
    }
    // Non-blocking Google Fonts load (removed from CSS @import to avoid render-blocking)
    if (!document.querySelector('link[href*="fonts.googleapis.com/css2"]')) {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap';
      fontLink.media = 'print';
      fontLink.onload = function () {
        ;
        (this as HTMLLinkElement).media = 'all';
      };
      document.head.appendChild(fontLink);
    }
    // Performance: Preload LCP hero image
    if (!document.querySelector('link[href*="lolo.png"]')) {
      const preloadImg = document.createElement('link');
      preloadImg.rel = 'preload';
      preloadImg.as = 'image';
      preloadImg.href = 'https://cdn.magicpatterns.com/uploads/3Atpf6s1M3vQ51aGZJxYf8/lolo.png';
      preloadImg.setAttribute('fetchpriority', 'high');
      document.head.insertBefore(preloadImg, document.head.firstChild);
    }
    // SEO: Add title
    document.title = 'Método Mesa en Paz — El Sistema para Familias con Niños Selectivos';
    // Meta Pixel - Deferred to not block initial render
    const loadPixel = () => {
      const w = window as any;
      if (!w.fbq) {
        const n: any = w.fbq = function (...args: any[]) {
          n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
        };
        w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '904978025482552');
      w.fbq('track', 'PageView');
      const noscript = document.createElement('img');
      noscript.height = 1;
      noscript.width = 1;
      noscript.style.display = 'none';
      noscript.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
      document.body.appendChild(noscript);
    };
    // Defer pixel load until browser is idle or after 2 seconds
    let pixelTimer: ReturnType<typeof setTimeout>;
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      pixelTimer = setTimeout(loadPixel, 2000);
    }
    return () => {
      if (pixelTimer) clearTimeout(pixelTimer);
    };
  }, []);
  return <SalesPage data-id="element-0" />;
}